<template>
  <ProjectTable
    :fixedPagination="true"
    :projectStatus="$route.params.status"
    :queryFilter="queryFilter"
    :querySorter="querySorter"
    :queryPager="queryPager"
    :addButton="{ name: 'projectsNew'}"
    @filter-changed="onFilterChanged"
    @sorter-changed="onSorterChanged"
    @pager-changed="onPageChanged"
  ></ProjectTable>
</template>

<script>
import ProjectTable from 'CORE/components/project/table'
import PersistentQueryMixin from 'CORE/mixins/persistent-query'

export default {
    name: 'ProjectTableView',
    components: {
        ProjectTable,
    },
    mixins: [
        PersistentQueryMixin,
    ],
}
</script>
